// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.
import { LoadablePaint, LoadableAfterPaint, LoadableLazy } from '@confluence/loadable';

export const LazySpaceBlogRedirect = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceBlogRedirect" */ '../SpaceBlogRedirect/index.ts'
			)
		).SpaceBlogRedirect,
});

export const LazySpaceCreatePage = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-containersCreatePageContainer" */ '../../containers/CreatePageContainer/index.js'
		),
});

export const LazyMobileWebContainer = LoadablePaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-MobileWebContainer" */ '../MobileWebContainer/index.js'),
});

export const LazyDwellTime = LoadableLazy({
	loader: () => import(/* webpackChunkName: "loadable-DwellTime" */ '../DwellTime/index.ts'),
});

// this is to fix an error in typechecking because the ConsumptionViewedAndCompletedEventTracker type is not exported
/** @type {any} */
export const LazyConsumptionViewedAndCompletedEventTracker = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluenceunified-analyticsentry-pointsConsumptionViewedAndCompletedEventTracker" */ '@confluence/unified-analytics/entry-points/ConsumptionViewedAndCompletedEventTracker.ts'
			)
		).ConsumptionViewedAndCompletedEventTracker,
});

export const LazyConfluenceNotFound = LoadableAfterPaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-containersConfluenceNotFoundContainer" */ '@confluence-classic/confluence-utils/src/components/ConfluenceNotFound/ConfluenceNotFoundContainer.js'
		),
});
